// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2v3lL","type":"styles_type__2LEPY","choices":"styles_choices__2y_Jo"};